export default __webpack_public_path__ + "static/media/mixed.f01e40d8.png";